import IConfigReducer from "../reducers/interfaces/iConfigReducer";

const getConfig = (store: any) => store.get("config").toJS() as IConfigReducer;

const configSelectors = {
    isLoaded: (store: any) => getConfig(store).isLoaded
};

export default configSelectors;
